export default __webpack_public_path__ + "static/EDUbox-lecture-game-16a4b7c95684e8fecb490c79b6a31021.png";